import { frontendURL } from '../../../helper/URLHelper';
import Index from './Index.vue';
import Dividas from './Dividas.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/disparo'),
    name: 'disparo_home',
    component: Index,
    meta: {
      permissions: ['administrator', 'agent'],
    },
    children: [
      {
        path: 'dividas',
        name: 'disparo_dividas',
        component: Dividas,
        meta: {
          permissions: ['administrator', 'agent'],
        },
      },
    ],
  },
];

export default { routes };
